module.exports = __webpack_public_path__ + "dist/fonts/roboto/Roboto-MediumItalic-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./dist/fonts/roboto/Roboto-MediumItalic-webfont.woff
// module id = 1637
// module chunks = 0